import { fetchApiJson, getEndpointForFetch } from "../data-layer/fetch-api";
import { SwarovskiOptikClientCart } from "@swo/storefront";
import * as E from "fp-ts/lib/Either";
import { Either } from "fp-ts/lib/Either";

export type GetCartResponseT = Either<
  "shopping-not-possible" | "shopping-currently-not-possible" | "unauthorised",
  SwarovskiOptikClientCart | null
>;

export const getCart = (
  token: string,
  localeCode: string,
  segmentKey: string,
  signal: AbortSignal | undefined,
  recoverCartId: string | null,
  baseUrl?: URL | undefined,
): Promise<GetCartResponseT> => {
  const searchParams = new URLSearchParams();
  if (recoverCartId) {
    searchParams.append("recoverCartId", recoverCartId);
  }

  const search = searchParams.toString();

  return fetchApiJson<GetCartResponseT>(
    getEndpointForFetch(`/storefront/shop/me/${localeCode}/${segmentKey}/cart`, baseUrl) + (search ? `?${search}` : ""),
    {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal,
    },
  ).catch(err => {
    if (err?.status === 401) {
      return E.left("unauthorised");
    } else {
      return E.left("shopping-currently-not-possible");
    }
  });
};
